<template lang="pug">
div
  announcement
  .container
    .member-wrapper
      memberMenu
      .member-content.statement
        .member-title {{ $t("ui.statement") }}
        .member-statement
          .menu-statement
            ul
              li(:class= "{ 'active': statementMode === 0}")
                a(href='javascript:void(0);' @click="statementMode = 0") {{ $t("ui.statement") }}
              li(:class= "{ 'active': statementMode === 1}")
                a(href='javascript:void(0);' @click="statementMode = 1") {{ $t("ui.transaction_history") }}
              template(v-if="accountGroup === 'WI'")
                li(:class= "{ 'active': statementMode === 2}")
                  a(href='javascript:void(0);' @click="statementMode = 2") {{ $t("ui.transfer_history") }}
              li(:class= "{ 'active': statementMode === 3}")
                a(href='javascript:void(0);' @click="statementMode = 3") {{ $t("ui.bet_history") }}
          .table-statement
            dailyStatement(v-if="statementMode === 0" @redirectBet="showBet")
            transactionHistory(v-if="statementMode === 1")
            template(v-if="accountGroup === 'WI'")
              transferHistory(v-if="statementMode === 2")
            betHistory(v-if="statementMode === 3")
  //- seo
</template>

<script>

export default {
  components: {
    announcement: () => import("@/components/_announcement"),
    memberMenu: () => import("@/components/_memberMenu"),
    dailyStatement: () => import("@/components/_dailyStatement"),
    transactionHistory: () => import("@/components/_transactionHistory"),
    transferHistory: () => import("@/components/_transferHistory"),
    betHistory: () => import("@/components/_betHistory"),
    seo: () => import("@/components/_seo")
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      statementMode: 1
    }
  },
  validations: { },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    workingDate() {
      return this.$store.getters.workingDate
    },
    accountGroup() {
      return this.$store.getters.accountGroup
    }
  },
  methods:{
    showBet(){
      this.statementMode = 3
    }
  }
}
</script>